import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js'
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class MpgTypeSelection extends BaseComponent {
	
	static get properties() {
		return {
			mpgType: {type: String},
			companyId: {type: String},
			unitGroupId: {type: String},
			// Required so dl-form-panel.getData() includes this control (child.name).
			name: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.mpgType = 'UNIT_MPG';
		
		var mpgTypeSelection = this;
		
		setTimeout(function(){
			mpgTypeSelection.init();
		});
	}
	
	render() {	
		return html`
			<style>
				.container {
					width: 100%;
					display: flex;
					flex-direction: row;					
				}
					
				.selection-text {
					flex: 1;
					margin-left: 10px;
					border: 1px dashed grey;
					padding: 5px;
					height: 30px;
				}
						
			</style>
			<div class="container">
				<vaadin-button itemid='select' @click='${this.clickSelect}'>
					<vaadin-icon icon="vaadin:road"></vaadin-icon> Select MPG Type				
				</vaadin-button>
				<span itemid='text' class="selection-text">
					Unit MPG
				</span>
			</div>
		`;
	}
	
	init() {
		var mpgTypeSelection = this;
			
		mpgTypeSelection.value = {
			type: mpgTypeSelection.mpgType,
			mpgOverride: 7,
			mpgOverrideTargets: {				
			}
		};	
		
		mpgTypeSelection.mpgTypeLooks = [
			{code: 'UNIT_MPG', description: 'Unit'},
			{code: 'FLEET_MPG', description: 'Fleet'},
			{code: 'UNIT_TARGETS', description: 'Unit Targets'},
			{code: 'MPG_OVERRIDE', description: 'MPG Override'},
			{code: 'REPORT_OPTION_TARGETS', description: 'MPG Targets'}
		];
		
		mpgTypeSelection.actionSelectType = function (type) {
			var description = '';
			mpgTypeSelection.mpgTypeLooks.forEach(function(item){
				if (item.code === type) {
					description = item.description;
				}
			});


			ElementUtil.query(mpgTypeSelection, 'text').innerHTML = description;
		};		
		
			
		var readyEvent = new CustomEvent('ready', { detail: '' });
		mpgTypeSelection.dispatchEvent(readyEvent);		
	}
	
	clickSelect() {
		var mpgTypeSelection = this;

		var selectWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Select MPG Type',
			icon: 'vaadin:road',				
			width: 600,
			height: 400,
			listeners: {
				ready: function() {						
					selectWin.show();

					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-combo-box',
										itemId: 'mpgType',
										label: 'MPG Type',
										'item-value-path': 'code',
										'item-label-path': 'description',
										name: 'mpgType',
										required: true,
										postinit: function (combo) {											
											combo.items = mpgTypeSelection.mpgTypeLooks.slice(0);
										},
										placeHolder: 'Select',
										listeners: {
											change: function () {
												var mpgTypeCB = ElementUtil.query(formPanel, 'mpgType');
												var newValue = mpgTypeCB.value;
												
												var mpgOverride = ElementUtil.query(formPanel, 'mpgOverride');
												mpgOverride.classList.add('hide');
												
												var mpgOverridePrefs = ElementUtil.query(formPanel, 'mpgOverridePrefs');
												mpgOverridePrefs.classList.add('hide');
												
												if ('MPG_OVERRIDE' === newValue) {
													mpgOverride.classList.remove('hide');
												} else if ('REPORT_OPTION_TARGETS' === newValue)  {
													mpgOverridePrefs.classList.remove('hide');
												}												
											}
										}
									}									
								]
							},
							{
								tag: 'vaadin-number-field',
								itemId: 'mpgOverride',
								name: 'mpgOverride',
								style: 'width: 100%',
								'class': 'hide',
								label: 'MPG Override'
							},
							{
								tag: 'br'
							},							
							{
								tag: 'fieldset',
								colspan: 2,
								itemId: 'mpgOverridePrefs',
								'class': 'hide',
								children: [
									{
										tag: 'legend',
										innerHTML: 'MPG Targets'
									},
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-number-field',
												label: 'Min MPG',
												name: 'mpgMinOverride',
												min: 0,
												max: 1000
											},
											{
												tag: 'vaadin-number-field',
												label: 'Min MPG Override Value',
												name: 'mpgMinOverrideDefault',
												min: 0,
												max: 1000
											},
											{
												tag: 'vaadin-number-field',
												label: 'Between Min MPG',
												name: 'mpgBetweenMinOverride',
												min: 0,
												max: 1000
											},
											{
												tag: 'vaadin-number-field',
												label: 'Between Max MPG',
												name: 'mpgBetweenMaxOverride',
												min: 0,
												max: 1000
											},
											{
												tag: 'vaadin-number-field',
												label: 'Between Override Value',
												name: 'mpgBetweenOverrideDefault',
												min: 0,
												max: 1000
											},
											{
												tag: 'div'
											},
											{
												tag: 'vaadin-number-field',
												label: 'Max MPG',
												name: 'mpgMaxOverride',
												min: 0,
												max: 1000
											},
											{
												tag: 'vaadin-number-field',
												label: 'Max MPG Override Value',
												name: 'mpgMaxOverrideDefault',
												min: 0,
												max: 1000
											}
										]
									}
								]
							},
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:check', ' Select')
												],
												listeners: {
													click: function () {

														if (formPanel.isValid()) {
															//update value														
															var data = formPanel.getData();
															
															mpgTypeSelection.value.type = data.mpgType;
															mpgTypeSelection.value.mpgOverride = data.mpgOverride;
															mpgTypeSelection.value.mpgOverrideTargets.mpgMaxOverride = data.mpgMaxOverride;
															mpgTypeSelection.value.mpgOverrideTargets.mpgMaxOverrideDefault = data.mpgMaxOverrideDefault;
															mpgTypeSelection.value.mpgOverrideTargets.mpgMinOverride = data.mpgMinOverride;
															mpgTypeSelection.value.mpgOverrideTargets.mpgMinOverrideDefault = data.mpgMinOverrideDefault;
															mpgTypeSelection.value.mpgOverrideTargets.mpgBetweenMaxOverride = data.mpgBetweenMaxOverride;
															mpgTypeSelection.value.mpgOverrideTargets.mpgBetweenMinOverride = data.mpgBetweenMinOverride;
															mpgTypeSelection.value.mpgOverrideTargets.mpgBetweenOverrideDefault = data.mpgBetweenOverrideDefault;
																												
														
															mpgTypeSelection.actionSelectType(mpgTypeSelection.value.type);														
															selectWin.close();
														}
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {													
														selectWin.close();
													}
												}
											}
										]
									}
								]
							}		
						]
					});
					
					selectWin.addToContentElement(formPanel);
							
					setTimeout(function(){
						formPanel.load({
							mpgType: mpgTypeSelection.value.type,
							mpgOverride: mpgTypeSelection.value.mpgOverride,
							mpgMaxOverride: mpgTypeSelection.value.mpgOverrideTargets.mpgMaxOverride,
							mpgMaxOverrideDefault: mpgTypeSelection.value.mpgOverrideTargets.mpgMaxOverrideDefault,
							mpgMinOverride: mpgTypeSelection.value.mpgOverrideTargets.mpgMinOverride,
							mpgMinOverrideDefault: mpgTypeSelection.value.mpgOverrideTargets.mpgMinOverrideDefault,
							mpgBetweenMaxOverride: mpgTypeSelection.value.mpgOverrideTargets.mpgBetweenMaxOverride,
							mpgBetweenMinOverride: mpgTypeSelection.value.mpgOverrideTargets.mpgBetweenMinOverride,
							mpgBetweenOverrideDefault: mpgTypeSelection.value.mpgOverrideTargets.mpgBetweenOverrideDefault
						}, {
							refreshComponents: true
						});	
					}, 100);		
								
					
				}
			}			
		});			

	}

	setCustomValue(value) {		
		var mpgTypeSelection = this;
					
		if (value) {	
			var data = JSON.parse(value);	
			mpgTypeSelection.value = data;
			
			mpgTypeSelection.actionSelectType(mpgTypeSelection.value.type);
		}
	}
	
	getCustomValue() {
		var mpgTypeSelection = this;
		if (!mpgTypeSelection.value) {
			mpgTypeSelection.value = {
				type: mpgTypeSelection.mpgType || 'UNIT_MPG',
				mpgOverride: 7,
				mpgOverrideTargets: {}
			};
		}
		return mpgTypeSelection.value;
	}
	
	updateMPGTargets(companyId, unitGroupId) {
		var mpgTypeSelection = this;	
		
		Service.getReportService().getMPGOverrides(companyId, unitGroupId).then(function(override) {
			if (!mpgTypeSelection.value) {
				mpgTypeSelection.value = {
					type: mpgTypeSelection.mpgType || 'UNIT_MPG',
					mpgOverride: 7,
					mpgOverrideTargets: {}
				};
			}
			mpgTypeSelection.value.mpgOverrideTargets = override || {};
										
		});		
	}
	
};
customElements.define('dl-mpgtype-selection', MpgTypeSelection);